
import React from 'react';
import style from './style.scss'
import newId from '../../utils/newid';

const RenderSectionID = (props) => {
    const {item, field} = props;
    const id = newId();
    return (
        <div className="form-group">
            {(typeof item.label !== 'undefined') ?
                <label  htmlFor={id}>
                    {
                        (typeof item.label === 'string') ? item.label : item.label.first}
                </label> : ''}

            <input type="text" id={id} value={(typeof field !== "undefined") ? field[item.item] : ""}
                   onChange={(t) => {
                       return props.handleChange(t.target.value)
                   }}

            />
        </div>
    )
}

export default RenderSectionID;
